<template>
  <span class="user" v-if="user[type] && user[type].split('/').pop() !== 'missing.png'">
    <img :src="user[type]" />
  </span>
  <span class="user" v-else>
    <img :src="'https://secure.gravatar.com/avatar/' + user.email_md5 + '?s=' + width + '&d=identicon'" />
  </span>
</template>
<script>

export default {
  props: ['type', "user"],
  data: ()=>({

  }),
  computed: {
    width(){
      let avatar_width = 25
      switch (this.type.split('avatar_')[1]) {
        case 'small_thumb':
          avatar_width = 50;
          break
        case 'thumb':
          avatar_width = 150;
          break
        case 'medium':
          avatar_width = 300;
          break
      }
      return avatar_width
    }
  }

}
</script>
